import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './CopyBotMessageButton.module.css';

const COPIED_FEEDBACK_MS = 2000;

function CopyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect
        x="9"
        y="9"
        width="11"
        height="11"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

async function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!ok) {
    throw new Error('copy failed');
  }
}

export default function CopyBotMessageButton({ text }) {
  const { texts } = useSelector((state) => state.translate);
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleCopy = async () => {
    try {
      await copyTextToClipboard(text ?? '');
      setCopied(true);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setCopied(false);
        timeoutRef.current = null;
      }, COPIED_FEEDBACK_MS);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className={classes.wrap}>
      <button
        type="button"
        className={classes.button}
        onClick={handleCopy}
        aria-label={texts.copyAnswer}
        title={texts.copyAnswer}
      >
        <CopyIcon />
      </button>
      {copied ?
        <span className={classes.feedback} aria-live="polite">
          {texts.copied}
        </span>
        : null}
    </div>
  );
}
